var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPg4Gradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1512,
    height: 1163,
    viewBox: "0 0 1512 1163",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-21.8945 32.5026C-21.8945 32.5026 214.241 207.216 433.854 221.646C743.61 241.998 1096.33 0.784668 1096.33 0.784668L1747.46 32.5026V679.241C1747.46 679.241 1730.54 1048 1429.1 1140.15C1048.56 1256.49 392.396 890.106 392.396 890.106L-21.8945 679.241V32.5026Z",
    fill: "url(#paint0_linear_539_1529)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_539_1529",
    x1: 862.999,
    y1: 140.301,
    x2: 862.999,
    y2: 1083.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00582E",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPg4Gradient);
export default __webpack_public_path__ + "static/media/pg4_gradient.bf2b6683f2e6ed034c74ae0b858b7fc3.svg";
export { ForwardRef as ReactComponent };